﻿import {getHeightWithMargins, expressQuerySelector, expressQuerySelectorAll} from '../common/html';
import {createUsps} from "../components/usp";
import {createCustomSlider, ICustomPhotoSliderItem} from "../components/customslider";
import {stopSkeletonLoading} from "../components/skeleton";
import {createGeneralPageEventsAndComponents} from "../components/page-general";
import { trackEvent } from '../common/events';

window.addEventListener('load', () => {
	createGeneralPageEventsAndComponents();

	const uspDesktopEl = expressQuerySelector<HTMLElement>(document, '.technical-usp-desktop');
	const homepageElementsContainerEl = expressQuerySelector<HTMLElement>(document, '.technical-homepage-elements');

	// Initialize the usp's
	if (uspDesktopEl) {
		createUsps(uspDesktopEl);
	}

	if (homepageElementsContainerEl) {
		// get all sliders
		const sliders = expressQuerySelectorAll<HTMLElement>(homepageElementsContainerEl, '.technical-slider');
		for (let i = 0, l = sliders.length; i < l; i++) {
			const sliderEl = sliders[i];

			// convert so slider elements
			const sliderElements: ICustomPhotoSliderItem[] = [];

			for (let z = 0, l = sliderEl.children.length; z < l; z++)
				sliderElements.push({template: sliderEl.children[z] as HTMLElement});

			// settings for slider
			const settings = {
				sliderElements: sliderElements,
				sliderContainerSettings: {
					extraSliderClass: 'm-product-slider__slider-container',
					elementsContainerSettings: {
						extraSliderClass: 'm-product-slider__slider-content',
						SlideClicked: () => {
							return;
						}
					},
					cssWhenButtonsBothOnMax: 'u-hide',
					nextButton: {
						css: 'a-button m-product-slider__button m-product-slider__button--next icon-arrow-right technical-slider-button',
						cssWhenOnMax: 'a-button--disabled',
						onClick: (draggedSlider: boolean) => {
							trackEvent('HomePageSliders', `nextbutton_${draggedSlider ? 'dragged' : 'clicked'}`, `slider ${i}`, -1);
							return;
						}
					},
					previousButton: {
						css: 'a-button m-product-slider__button m-product-slider__button--prev icon-arrow-left technical-slider-button',
						cssWhenOnMax: 'a-button--disabled',
						onClick: (draggedSlider: boolean) => {
							trackEvent('HomePageSliders', `prevbutton_${draggedSlider ? 'dragged' : 'clicked'}`, `slider ${i}`, -1);
							return;
						}
					},
				},
				showHalfSlides: false,
				replaceWithElement: true,
				enableEternalSliding: false,

				// height script buttons
				SliderCreated: (settings, slider, oldslider) => {
					// slider elements are on the DOM
					const visibleSlides = expressQuerySelectorAll(oldslider ? oldslider : sliderEl, '.technical-slide') as HTMLElement[];
					// new slider elements that has not been added to the DOM yet
					// Do this for the height script => minimize flikker, drag, slide, ... of elements when slider is on DOM
					const invisibleSlides = expressQuerySelectorAll(slider, '.technical-slide') as HTMLElement[];

					const highestSlideEl = getHighestSlideOfSlider(visibleSlides);
					const highestSlideTitle = expressQuerySelector<HTMLElement>(highestSlideEl, '.technical-tile-title', false);
					const highestSlideSubTitle = expressQuerySelector<HTMLElement>(highestSlideEl, '.technical-tile-subtitle', false);

					const highestSlideTitlepx = highestSlideTitle ? getHeightWithMargins(highestSlideTitle) : 0;
					const highestSlideSubTitlepx = highestSlideSubTitle ? getHeightWithMargins(highestSlideSubTitle) : 0;
					const highestSlideFullTitlepx = highestSlideTitlepx + highestSlideSubTitlepx;

					if (highestSlideFullTitlepx > 0)
						heightScriptSlides(invisibleSlides, highestSlideFullTitlepx);

					heightScriptButtons(slider, highestSlideFullTitlepx, highestSlideEl);
				},
				ResizeEvent: (settings, slider) => {
					const visibleSlides = expressQuerySelectorAll(slider, '.technical-slide') as HTMLElement[];
					const highestSlideEl = getHighestSlideOfSlider(visibleSlides);
					const highestSlideTitle = expressQuerySelector<HTMLElement>(highestSlideEl, '.technical-tile-title', false);
					const highestSlideSubTitle = expressQuerySelector<HTMLElement>(highestSlideEl, '.technical-tile-subtitle', false);

					const highestSlideTitlepx = highestSlideTitle ? getHeightWithMargins(highestSlideTitle) : 0;
					const highestSlideSubTitlepx = highestSlideSubTitle ? getHeightWithMargins(highestSlideSubTitle) : 0;
					const highestSlideFullTitlepx = highestSlideTitlepx + highestSlideSubTitlepx;

					if (highestSlideFullTitlepx > 0)
						heightScriptSlides(visibleSlides, highestSlideFullTitlepx);

					heightScriptButtons(slider, highestSlideFullTitlepx, highestSlideEl);
				}
			};

			// create slider
			if (sliderEl.parentElement) createCustomSlider(sliderEl.parentElement, settings);
		}
	}

	// Set height of slides
	const heightScriptSlides = (slidesInSlider: HTMLElement[], highestSlideFullTitlepx: number) => {
		// SLIDES
		for (let i = 0, l = slidesInSlider.length; i < l; i++) {
			const slideFullTitleEl = expressQuerySelector<HTMLElement>(slidesInSlider[i] as HTMLElement, '.technical-slide-title', false);

			if (slideFullTitleEl && highestSlideFullTitlepx > 0)
				slideFullTitleEl.style.height = `${highestSlideFullTitlepx}px`;
		}
	};

	// Set height of buttons
	const heightScriptButtons = (slider: HTMLElement, titleHeight: number, highestSlideEl: HTMLElement) => {
		// BUTTONS
		const sliderButtons = expressQuerySelectorAll(slider, '.technical-slider-button');
		const hightestImage = expressQuerySelector<HTMLElement>(highestSlideEl, '.technical-slide-imageContainer', false);
		let buttonCenterImage = 0;
		if (hightestImage) {
			const hightestImagepx = hightestImage.offsetHeight;
			let bottom = highestSlideEl.offsetHeight - (hightestImagepx + titleHeight);
			if (bottom < 0) bottom = 0;
			buttonCenterImage = bottom + (hightestImagepx / 2);
		}

		for (let i = 0, l = sliderButtons.length; i < l; i++) {
			(sliderButtons[i] as HTMLElement).style.bottom = `${buttonCenterImage > 0 ? buttonCenterImage : (highestSlideEl.offsetHeight / 2)}px`;
		}
	};

	// Gets the highest slide element in the slider elements
	const getHighestSlideOfSlider = (slidesInSlider: HTMLElement[]): HTMLElement => {
		let highestSlideEl: HTMLElement;
		let maxTitleHeight = 0;

		for (let i = slidesInSlider.length - 1; i >= 0; i--) {
			const slideEl = slidesInSlider[i] as HTMLElement;
			const sliderTitleEl = expressQuerySelector<HTMLElement>(slideEl, '.technical-slide-title', false);
			const sliderTitle = expressQuerySelector<HTMLElement>(slideEl, '.technical-tile-title', false);
			const sliderSubTitle = expressQuerySelector<HTMLElement>(slideEl, '.technical-tile-subtitle', false);

			const titleHeight = sliderTitle ? getHeightWithMargins(sliderTitle) : 0;
			const subTitleHeight = sliderSubTitle ? getHeightWithMargins(sliderSubTitle) : 0;
			const titleheight = titleHeight + subTitleHeight;

			// reset height
			if (sliderTitleEl)
				sliderTitleEl.style.height = '';

			if (maxTitleHeight <= titleheight) {
				maxTitleHeight = titleheight;
				highestSlideEl = slideEl;
			}
		}

		return highestSlideEl!;
	};

	stopSkeletonLoading();
});
